// ── Formatting ─────────────────────────────────────────────────────────────────

export const formatDuration = (ms: number): string => {
  const mins = Math.floor(ms / 60_000)
  const hrs = Math.floor(mins / 60)
  const days = Math.floor(hrs / 24)
  if (days >= 365) return '1 year'
  if (days >= 30) return '30 days'
  if (days >= 7) return '7 days'
  if (days >= 1) return `${days} day${days > 1 ? 's' : ''}`
  if (hrs >= 1) return `${hrs} hour${hrs > 1 ? 's' : ''}`
  return `${mins} minute${mins !== 1 ? 's' : ''}`
}

// ── Safe callback execution ────────────────────────────────────────────────────

/** Runs a sync callback; swallows and logs any error so it never crashes the middleware. */
export const safeExec = (label: string, fn: () => void): void => {
  try {
    fn()
  } catch (err) {
    console.error(`[rate-shield] Unhandled error in ${label}:`, err)
  }
}

/** Async variant of safeExec. */
export const safeExecAsync = async (
  label: string,
  fn: () => Promise<void> | void
): Promise<void> => {
  try {
    await fn()
  } catch (err) {
    console.error(`[rate-shield] Unhandled error in ${label}:`, err)
  }
}
